// FILE: src/components/Section/Section.jsx
import React from "react";
import styles from "./Section.module.css";

export default function Section({ id, className = "", children }) {
  return (
    <section id={id} className={`${styles.section} ${className}`} style={{ scrollMarginTop: 80 }}>
      {children}
    </section>
  );
}
